import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import CompositiontemplateEditForm from './CompositiontemplateEditForm';
import CompositiontemplateList from './CompositiontemplateList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import CompositiontemplateListView from './CompositiontemplateListView'


export default function CompositiontemplateDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.compositiontemplateDashboard);
  const [ compositiontemplateId, setCompositiontemplateId] = React.useState('');
  const [reloadCompositiontemplateList, setReloadCompositiontemplateList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <CompositiontemplateEditForm 
            setReloadCompositiontemplateList={setReloadCompositiontemplateList}
            compositiontemplateId={compositiontemplateId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <CompositiontemplateListView 
                      setCompositiontemplateId = {setCompositiontemplateId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
